import { render, staticRenderFns } from "./indexc.vue?vue&type=template&id=5a55c4df&scoped=true"
import script from "./indexc.vue?vue&type=script&lang=js"
export * from "./indexc.vue?vue&type=script&lang=js"
import style0 from "./indexc.vue?vue&type=style&index=0&id=5a55c4df&prod&lang=css"
import style1 from "./indexc.vue?vue&type=style&index=1&id=5a55c4df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a55c4df",
  null
  
)

export default component.exports